var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCardEncoder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Card_Encoder"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Card_Encoder",
    "data-name": "Card Encoder",
    clipPath: "url(#clip-Card_Encoder)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "atm-card_8241587_1_",
    "data-name": "atm-card_8241587 (1)",
    transform: "translate(88 -49) rotate(90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SOLID",
    transform: "translate(49 8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_342",
    "data-name": "Path 342",
    d: "M72.333,34.667v26A7.329,7.329,0,0,0,79.667,68h38.667a7.329,7.329,0,0,0,7.333-7.333v-26h16A7.333,7.333,0,0,0,149,27.333v-12A7.329,7.329,0,0,0,141.667,8H56.333A7.329,7.329,0,0,0,49,15.333v12a7.333,7.333,0,0,0,7.333,7.333Zm13.333-10H79v36a.671.671,0,0,0,.667.667h6Zm40,3.333h16a.669.669,0,0,0,.667-.667v-12a.672.672,0,0,0-.667-.667H56.333a.672.672,0,0,0-.667.667v12a.669.669,0,0,0,.667.667h16V24.667H69A3.333,3.333,0,0,1,69,18h60a3.333,3.333,0,0,1,0,6.667h-3.333Z",
    transform: "translate(-49 -8)",
    fill: "#e8eaf0",
    fillRule: "evenodd"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardEncoder);
export default __webpack_public_path__ + "static/media/card-encoder.e49e7764c9c30ef1462ed8f6644d5615.svg";
export { ForwardRef as ReactComponent };